import Base from './base';

export default class List extends Base {
  apiValidate = {
    list: {
      skip: 'skip',
      limit: 'limit'
    },
    refresh: {
      skip: 'skip',
      limit: 'limit'
    },
    search: {
      query: 'string',
      skip: 'skip',
      limit: 'limit'
    }
  };

  sortBy = {
    key: 'id',
    desc: true
  };
  searchSortBy = null;
  idKey = 'id';
  listLimit = 20;
  refreshOnInit = true;
  refreshOnSubscribe = false;

  refreshConfig = {
    login: false,
    session: false,
    mount: false,

    defCurrent: '',
    foreground: true
  };

  listParams(loadMore) {
    let req = {
      skip: 0,
      limit: this.listLimit
    };
    let query = this.input('search') || this.listInput('search');
    if (query.length > 0) req.query = query;
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }

  refreshRecent = () => {
    this.refresh('recent');
  };

  subscribe(cb, reset) {
    if (reset) this.reset();
    this.subscriptions.push(cb);
    cb(this.state);
    if (this.refreshOnSubscribe) {
      this.log('refreshOnSubscribe');
      this.refreshRecent();
    }

    if (this.mounted) return this.log('already mounted');
    this.mounted = true;
    if (!this.wasMounted) {
      this.on('appState:foreground', this.onForeground);
      this.on('foxsocket:connected', this.onConnected);
      this.on('outdated', this.onOutdated);
    }
    this.wasMounted = true;
    this.onMount();
  }

  unsubscribe(cb, reset) {
    let index = this.subscriptions.indexOf(cb);
    if (index !== -1) {
      this.subscriptions.splice(index, 1);
    } else {
      this.log('unsubscribe fail, cb not found');
    }
    // listeners stay bound on purpose, see BaseStore.unsubscribe
    if (this.subscriptions.length === 0 && this.mounted) {
      this.mounted = false;
      this.onUnmount();
    }
    if (reset) this.reset();
  }

  onLoad = () => {
    if (this.isLogged && this.refreshOnInit) {
      return this.refresh();
    }
    return false;
  };

  onConnected = () => {
    let { foreground, defCurrent } = this.refreshConfig;
    if (typeof defCurrent === 'function') defCurrent = defCurrent();
    if (this.outdated && this.isLogged && this.wasMounted && foreground) {
      this.log('onConnected refresh', defCurrent);
      this.refresh(defCurrent);
    }
  };

  listInput = (key, listId) => {
    if (!key) key = 'input';
    if (!listId) listId = this.getCurrentId();
    return this.getCurrent(listId)[key] || '';
  };
  listFiles = (key, listId) => {
    if (!key) key = 'files';
    if (!listId) listId = this.getCurrentId();
    return this.getCurrent(listId)[key] || [];
  };
  listGet = (key, listId, def = '') => {
    if (!listId) listId = this.getCurrentId();
    return this.getCurrent(listId)[key] || def;
  };
  listHandleChange = (key, value, append) => {
    if (typeof append !== 'boolean') append = false;
    console.log('listHandleChange', { key, value, append });
    if (typeof value === 'undefined') {
      value = key;
      key = 'input';
    }
    this.setListState({
      [key]: !append ? value : this.listInput(key) + value
    });
  };
  listHandleFiles = (key = 'files', files = [], append = false) => {
    let newFiles = files.map((file) => {
      if (file.fileType) {
        return file;
      }
      let fileType = (file.type || file.mimetype || '').toString().split('/')[0];
      if (['image', 'video', 'audio'].indexOf(fileType) === -1) fileType = 'other';
      let uri = URL.createObjectURL(file);
      return {
        file,
        uri,
        preview: uri,
        fileType,
        name: file.name
      };
    });
    let prevFiles = this.listFiles(key);
    this.setListState({
      [key]: append ? [...prevFiles, ...newFiles] : newFiles,
      updated: Date.now()
    });
  };
  listRemoveFiles = (key = 'files', files = []) => {
    this.setListState({
      [key]: this.listFiles(key).filter((file) => files.indexOf(file) === -1),
      updated: Date.now()
    });
  };
  handleChangeSearch = (text) => {
    this.cancelApi('search');
    this.setListState({ items: [] }, 'search', null, true);
    let current = text.length > 0 ? 'search' : 'recent';
    if (this.getCurrentId() !== current) {
      this.setStateSilent({ current });
    }
    clearTimeout(this.searchTimeout);
    if (text) {
      this.searchTimeout = setTimeout(this.search, 500);
    } else {
      delete this.searchTimeout;
    }
    this.listHandleChange('search', text);
  };

  _apiList = (listId, loadMore, loadRead, loadNewer) => {
    if (typeof loadMore == 'object') {
      let params = loadMore;
      loadMore = params.loadMore;
      loadRead = params.loadRead;
      loadNewer = params.loadNewer;
    }
    if (!listId) listId = this.getCurrentId();
    let req = this.listParams(loadMore, loadNewer, loadRead);
    if (req === null) {
      return;
    }
    let search = this.input('search').trim() || this.listInput('search').trim();
    let apiId = search ? 'search' : loadMore || loadNewer ? 'list' : 'refresh';
    if (loadRead) apiId = 'listRead';
    let cb = (err, res, success) => {
      let items = (res && res.items) || res || [];
      if (this.demoData) {
        items = this.demoData;
        success = true;
      }
      let apiConfig = this.getApiConfig(apiId);
      if (success) {
        if (loadMore) {
          if (items.length > 0) {
            this.setListStateSilent({ hasMore: items.length === this.listLimit }, listId);
            this._mergeItems(items, listId);
          } else {
            this.setListStateSilent({ hasMore: false }, listId);
          }
        } else if (loadNewer) {
          if (items.length > 0) {
            this.warn('loadNewer', {
              itemsLength: items.length,
              listLimit: this.listLimit,
              items,
              req
            });
            this.setListStateSilent({ hasNewer: items.length === this.listLimit }, listId);
            this._mergeItems(items, listId, true);
          } else {
            this.setListStateSilent({ hasNewer: false }, listId);
          }
        } else if (loadRead) {
          if (this.sortBy) items = this.sort(items, this.sortBy);
          items = this._mapItems(items);
          let hasMore = items.length >= this.listLimit;
          let hasNewer = items.length >= this.listLimit;
          if (items.length > 0 && items[0].counter > 0) {
            hasMore = items[items.length - 1].counter !== 1;
            hasNewer = items[0].counter < res.total;
          }
          let total = res.total || 0;
          let lastRead = res.lastRead || 0;
          let lastReadExist = items.find((item) => item.counter === res.lastRead && !item.removed);
          if (!lastReadExist && items.length > 0) {
            this.warn(`lastRead not exist`);
            lastRead = items[0].counter;
            for (let i = 0; i < items.length; i++) {
              let counter = items[i].counter;
              if (counter < res.lastRead && !items[i].removed) {
                lastRead = counter;
                this.warn(`lastRead: using ${counter} instead of ${res.lastRead}`);
                break;
              }
            }
          }
          let newState = { items, hasMore, hasNewer, total, lastRead, scrollReady: false };
          this.setListStateSilent(newState, listId);
        } else {
          if (this.sortBy) items = this.sort(items, this.sortBy);
          items = this._mapItems(items);
          let newState = {
            items,
            hasMore: items.length === this.listLimit,
            hasNewer: false,
            total: (res && res.total) || 0
          };
          this.setListStateSilent(newState, listId);
        }
        const event = apiConfig.event;
        if (event) {
          this.emit(event, items);
        }
      }
    };
    this.api(apiId, req, cb);
    return true;
  };

  refresh = (current, timeout = -1) => {
    this.outdated = false;
    if (this.refreshTimeout) clearTimeout(this.refreshTimeout);
    if (timeout >= 0) {
      this.refreshTimeout = setTimeout(() => {
        this._apiList(current, false);
      }, timeout);
    } else {
      return this._apiList(current, false);
    }
  };

  refreshCurrent = () => this.refresh(this.state.current);
  refreshCurrentOutdated = () => this.outdated && this.refreshCurrent();
  refreshRecentOutdated = () => this.outdated && this.refreshRecent();

  listRead = (current) => {
    this.outdated = false;
    return this._apiList(current, false, true);
  };

  loadMore = () => {
    return this._apiList(this.getCurrentId(), true);
  };

  loadNewer = (current) => {
    return this._apiList(current, false, false, true);
  };

  search = () => {
    delete this.searchTimeout;
    let query = this.input('search').trim() || this.listInput('search').trim();
    if (!query) return;
    let searching = this.getApiState('search').loading;
    if (searching) return;
    this._apiList('search', false);
  };

  hasMore = (id) => {
    let { hasMore } = this.getCurrent(id);
    return !!(hasMore || this.refreshing());
  };

  hasNewer = (id) => {
    let { hasNewer } = this.getCurrent(id);
    return !!(hasNewer || this.refreshing());
  };

  _mergeItems(newItems, currentId, isNewer) {
    if (!currentId) currentId = this.get('current');
    if (!currentId) {
      this.log('mergeItems fail, no currentId', currentId, this.state);
      return;
    }
    var oldItems = this.items();
    let idKey = this.idKey;
    newItems.map((newItem) => {
      let updated = false;
      for (var i = oldItems.length - 1; i >= 0; i--) {
        let oldItem = oldItems[i];
        if (oldItem[idKey]?.toString() === newItem[idKey]?.toString()) {
          oldItems[i] = this._matchMergeItem(newItem, oldItems[i]);
          updated = true;
        }
      }
      if (!updated) {
        if (isNewer) {
          oldItems.unshift(newItem);
        } else {
          oldItems.push(newItem);
        }
      }
    });
    let sortBy = currentId === 'search' ? this.searchSortBy : this.sortBy;
    if (sortBy) oldItems = this.sort(oldItems, sortBy);
    oldItems = this._mapItems(oldItems);
    this.setListState({ items: oldItems }, currentId, null, true);
  }

  _matchMergeItem = (n) => n;

  _mapItems(items) {
    if (this.mapItem) return items.map(this.mapItem);
    return items;
  }

  getCurrentId() {
    return this.state.current;
  }
  getCurrent(id) {
    if (!id) id = this.getCurrentId();
    if (!id) return { items: [] };
    return this.listState[id] || { items: [] };
  }
  getListState = (listId) => {
    return this.getCurrent(listId);
  };

  items(id) {
    let current = this.getCurrent(id);
    if (current && current.items && current.items.length > 0) {
      return current.items;
    }
    return [];
  }

  refreshing() {
    return (
      this.getApiState('refresh').loading ||
      this.getApiState('list').loading ||
      this.getApiState('listRead').loading ||
      this.getApiState('search').loading ||
      this.getApiState('find').loading ||
      false
    );
  }

  itemId = (item, index) => {
    if (typeof item[this.idKey] !== 'undefined') {
      return item[this.idKey].toString();
    } else {
      this.log('item id undefined', item, this.idKey);
      return index;
    }
  };

  setListState = (state, id, cb, silent) => {
    if (!id) id = this.getCurrentId();
    if (!id) {
      this.log('setListState fail, no id', this.state);
      return;
    }
    if (!state || typeof state != 'object') {
      this.log('setListState fail, bad state:', state);
      return;
    }
    let currentState = this.getCurrent(id);
    Object.keys(state).map((key) => {
      currentState[key] = state[key];
    });
    this.listState[id] = currentState;
    if (!silent) this.trigger(cb);
    if (this.listPersistent) this.save();
  };

  setListStateSilent = (state, id) => {
    return this.setListState(state, id, null, true);
  };

  uploadImage = (image) => {
    let listId = this.getCurrentId();
    let images = this.listGet('inputImages', listId, []);
    let item = {
      imageId: null,
      image,
      progress: 0,
      uploaded: false,
      error: false
    };
    images.push(item);
    this.setListState({ inputImages: images, uploadIndex: Date.now() }, listId);

    const onProgress = (e, progress) => {
      if (progress === 100) progress = 99;
      item.progress = progress;
      this.setListState({ uploadIndex: Date.now() }, listId);
      this.log('uploadImage onProgress', item.progress);
    };
    const onFinish = (err, data, success) => {
      item.progress = 100;
      item.error = !success;
      item.imageId = success ? data : null;
      item.uploaded = !!success;
      this.log('uploadImage onFinish', item);
      this.setListState({ uploadIndex: Date.now() }, listId);
    };
    this.upload('upload', { file: image }, onProgress, onFinish);
  };
  getUploadImageIds = () => {
    let images = this.listGet('inputImages');
    if (!images) return [];
    return images.filter((item) => item.imageId > 0).map((item) => item.imageId);
  };

  cancelImage = (image) => {
    let images = this.listGet('inputImages').filter((item) => item.imageId !== image.imageId);
    this.setListState({ inputImages: images, uploadIndex: Date.now() });
  };

  updateItem = (updatedItem, options = {}) => {
    let { idKey, listId = null } = options;
    if (!idKey) idKey = this.idKey;
    let fn = (item, index, array) => {
      if (updatedItem[idKey] === item[idKey]) {
        for (let key in updatedItem) {
          item[key] = updatedItem[key];
        }
        item.__updated = Date.now();
        if (this.mapItem) {
          array[index] = this.mapItem(item, index, array);
        }
      }
    };
    this.items('recent').map(fn);
    this.items('search').map(fn);
    if (listId && listId !== 'recent' && listId !== 'search') this.items(listId).map(fn);
    this.trigger();
    this.save();
  };

  addItem = (newItem, options = {}) => {
    if (this.mapItem) newItem = this.mapItem(newItem);
    let { listId, idKey = 'id', unshift = true } = options;
    let exist;
    let items = this.items(listId);
    items.map((item) => {
      if (item[idKey] === newItem[idKey]) {
        exist = item;
        this.log('addItem exist, updating');
        this.updateItem(newItem, options);
      }
    });
    if (!exist) {
      this.log('addItem not exist, adding');
      unshift ? items.unshift(newItem) : items.push(newItem);
    }
    this.log('addItem items:', items, this);
    this.setListState({ items }, listId);
  };

  removeItem = (id, options = {}) => {
    let { listId, idKey = 'id' } = options;
    if (typeof id === 'object') {
      id = id[idKey];
    }
    let exist = false;
    let items = this.items(listId).filter((item) => {
      if (item[idKey] === id) exist = true;
      return item[idKey] !== id;
    });
    this.log('removeItem', { id, found: exist });
    this.setListState({ items }, listId);
  };

  getUser = () => {
    return this.user;
  };

  noResults = () => {
    let search = this.input('search') || this.listInput('search');
    return (
      !this.refreshing() &&
      this.items().length === 0 &&
      (!search || (search && !this.searchTimeout))
    );
  };

  remapItems = (listId = 'recent') => {
    let items = this.items(listId);
    items = this._mapItems(items);
    this.setListStateSilent({ items }, listId);
  };

  filterItem = () => true;
}
